import { Label } from "../../components/Label";
import { Radio } from "../../components/Radio";

import styles from "../../../styles/avaliacoes.module.scss";

import classNames from "classnames/bind";
import { Icon } from "../../components/core/Icon";
const cx = classNames.bind(styles);

const st = (className) => styles[className];

export default function EvaluateFilter({
  selectRating,
  selectFilterComment,
  filters,
  filterParams,
}) {
  const isSelected = (value) => {
    return filters.indexOf(value) > -1;
  };

  return (
    <>
      <Label>Filtrar avaliações por</Label>
      <div className={st("ratings")}>
        <div
          className={cx({
            rating: true,
            selected: isSelected(1),
          })}
          onClick={() => selectRating(1)}
        >
          <div className={st("star")}>
            <Icon size="1x" name="fa-star" solid />
          </div>
          <span>1,0</span>
        </div>
        <div
          className={cx({
            rating: true,
            selected: isSelected(2),
          })}
          onClick={() => selectRating(2)}
        >
          <div className={st("star")}>
            <Icon size="1x" name="fa-star" solid />
          </div>
          <span>2,0</span>
        </div>
        <div
          className={cx({
            rating: true,
            selected: isSelected(3),
          })}
          onClick={() => selectRating(3)}
        >
          <div className={st("star")}>
            <Icon size="1x" name="fa-star" solid />
          </div>
          <span>1,0 - 2,0</span>
        </div>
        <div
          className={cx({
            rating: true,
            selected: isSelected(4),
          })}
          onClick={() => selectRating(4)}
        >
          <div className={st("star")}>
            <Icon size="1x" name="fa-star" solid />
          </div>
          <span>2,0 - 3,0</span>
        </div>
        <div
          className={cx({
            rating: true,
            selected: isSelected(5),
          })}
          onClick={() => selectRating(5)}
        >
          <div className={st("star")}>
            <Icon size="1x" name="fa-star" solid />
          </div>
          <span>3,0 - 4,0</span>
        </div>
        <div
          className={cx({
            rating: true,
            selected: isSelected(6),
          })}
          onClick={() => selectRating(6)}
        >
          <div className={st("star")}>
            <Icon size="1x" name="fa-star" solid />
          </div>
          <span>4,0 - 5,0</span>
        </div>
        <div
          className={cx({
            rating: true,
            selected: isSelected(7),
          })}
          onClick={() => selectRating(7)}
        >
          <div className={st("star")}>
            <Icon size="1x" name="fa-star" solid />
          </div>
          <span>Todas</span>
        </div>
      </div>

      <div>
        <Label>Comentários</Label>
        <Radio
          family="comments"
          className="mb-10"
          value={true}
          checked={filterParams.obs === null || filterParams.obs === undefined}
          onChange={() => selectFilterComment(null)}
        >
          <p className="radio-label">Todos</p>
        </Radio>
        <Radio
          family="comments"
          className="mb-10"
          value={"false"}
          checked={filterParams.obs}
          onChange={() => selectFilterComment("false")}
        >
          <p className="radio-label">Sem comentários</p>
        </Radio>
        <Radio
          family="comments"
          value={"true"}
          checked={filterParams.obs}
          onChange={() => selectFilterComment("true")}
        >
          <p className="radio-label">Com comentários</p>
        </Radio>
      </div>
    </>
  );
}
